import { Button, Popup } from "semantic-ui-react";

export const PopupButton = (props: any) => {
    const { tooltip, buttonClass, buttonName, onClick } = props;
    return (<Popup
        content={tooltip}
        size="mini"
        trigger={
            <Button
                icon
                color="teal"
                className={buttonClass}
                onClick={() => {
                    onClick();
                }}
            >
                {buttonName}
            </Button>
        }
    />);
}